import { FC } from 'react';
import { KidTemplateSetupStatus } from '../../../../../api/kids/types';
import { cn } from '../../../../../utilities/cn';
import {
  formatTemplateSetupStatusLabel,
  templateSetupStatusBadgeClass,
} from '../templateManagement.constants';
import {
  getTemplateSetupStatusPills,
  TemplateSetupStatusPill,
} from '../templateManagement.helpers';

const pillTitle = (pill: TemplateSetupStatusPill): string | undefined => {
  if (pill.count == null) return undefined;
  if (pill.status === KidTemplateSetupStatus.INVALID) {
    return `Should be removed from ${pill.count} document${pill.count === 1 ? '' : 's'}`;
  }
  if (pill.status === KidTemplateSetupStatus.INCOMPLETE) {
    return `Missing from ${pill.count} document${pill.count === 1 ? '' : 's'}`;
  }
  return undefined;
};

const TemplateSetupStatusPills: FC<{
  setupStatus?: string | null;
  missingCount?: number;
  invalidCount?: number;
  className?: string;
}> = ({ setupStatus, missingCount, invalidCount, className }) => {
  const pills = getTemplateSetupStatusPills({
    setupStatus,
    missingCount,
    invalidCount,
  });

  if (pills.length === 0) {
    return <span className="text-gray-400">—</span>;
  }

  return (
    <span className={cn('inline-flex flex-wrap items-center gap-1.5', className)}>
      {pills.map((pill) => (
        <span
          key={pill.status}
          title={pillTitle(pill)}
          className={`inline-flex shrink-0 items-center whitespace-nowrap rounded px-2 py-0.5 text-xs font-bold capitalize leading-tight tracking-wide ring-1 ${templateSetupStatusBadgeClass(pill.status)}`}
        >
          {formatTemplateSetupStatusLabel(pill.status)}
          {pill.count != null ? ` (${pill.count})` : ''}
        </span>
      ))}
    </span>
  );
};

export default TemplateSetupStatusPills;
